// src/api/notificationService.js
// -----------------------------------------------------------------------------
// Calls for Notification_TBL (Requirement #22: in-app notifications for every
// action, plus Additional Requirement: email channel).
// -----------------------------------------------------------------------------
import axiosClient from './axiosClient';
import ENDPOINTS from './endpoints';

const notificationService = {
  getAll: (params = {}) => axiosClient.get(ENDPOINTS.NOTIFICATIONS, { params }),
  getByUser: (userID, params = {}) => axiosClient.get(ENDPOINTS.NOTIFICATION_BY_USER(userID), { params }),
  getUnreadByUser: (userID, params = {}) => axiosClient.get(ENDPOINTS.NOTIFICATION_UNREAD_BY_USER(userID), { params }),
  markAsRead: (notificationID) => axiosClient.put(ENDPOINTS.NOTIFICATION_MARK_READ(notificationID)),
  markAllAsRead: (userID) => axiosClient.put(ENDPOINTS.NOTIFICATION_MARK_ALL_READ(userID)),
  delete: (notificationID) => axiosClient.delete(ENDPOINTS.NOTIFICATION_BY_ID(notificationID)),
};

export default notificationService;
